import {TopContainer} from "../components/HomePage/TopContainer";
import {FooterContainer} from "../components/HomePage/Footer";
import React from "react";
import styles from './Layout.module.scss';


function withLayout(Component: React.FC) {
    return (
        <div className={styles['layout']}>
            <TopContainer/>
            <Component/>
            <FooterContainer/>
        </div>
    );
}

export default withLayout;